import { createContext, useContext } from 'react';
import { pairingStore } from './pairingStore';

const PairingContext = createContext<typeof pairingStore | null>(null);

export function PairingProvider({ children }: { children: React.ReactNode }) {
  return (
    <PairingContext.Provider value={pairingStore}>
      {children}
    </PairingContext.Provider>
  );
}

export function usePairingStore() {
  const store = useContext(PairingContext);
  if (!store) {
    throw new Error('usePairingStore must be used within a PairingProvider');
  }
  return store;
}
